import { create } from 'zustand'

const useViewAsUserStore = create((set) => ({
  // Currently selected user for "view as" feature, null means viewing as self
  activeUser: null,
  setActiveUser: (user) => set({ activeUser: user }),
  clearActiveUser: () => set({ activeUser: null }),
}))

export const useActiveUser = () => useViewAsUserStore((s) => s.activeUser)

export const useSetActiveUser = () => useViewAsUserStore((s) => s.setActiveUser)

export const useClearActiveUser = () =>
  useViewAsUserStore((s) => s.clearActiveUser)
